import { makeEditorModal } from '../Modal';
import { TinyMCE, Editor } from 'tinymce';
import { displayErrors, getData, getPoints, getRandomInt, getTaskId, insertToEditor, pointsValid, setWindowNode, toJsonHtml, transformLength } from '../core/Utils';
import { FeatureClass } from '../core/FeatureClass';
import { getModalInputId, insertData } from "../save/SaveUtils";
import { showInsertImage } from '../core/Image';

declare let tinymce:TinyMCE;

/**
 * Interfaces
 */

export interface LabelingData {
    id: number,
    solutions: Array<SingleLabel>;
    url: string;
    points: number | string;
    type: string;   // la || dr
    width?: number;
    height?: number;
    editorWidth?:number;
    editorHeight?:number;
}


interface SingleLabel {
    correct: string | number; // can either be string for la or number for dr that correspons with position
    top: number;
    left: number;
    width: number;
    value?: string|number;
}

interface SingleLabelSolution {
    correct: string | number;
    value?: string | number;
}

/**
 * Export
 * @param editor 
 */

export function addLabeling(editor:Editor){
    const config = {
        featureName: "labeling",
        editor: editor,
        id: "labeling",
        icon: "paste-row-before",
        tooltip: 'Beschriftung',
        menuItems: [{
            name: 'edit-labeling',
            icon: 'edit-block',
            text: 'Bearbeiten',
            action: (editor:Editor, command:string) => {
                const node = setWindowNode(editor);
                const data = getData(node);

                // Remember Height if it was changed in the editor!
                const imgHolder = $(node).find(".img-holder");
                const editorWidth = imgHolder.width();
                const editorHeight = imgHolder.height();

                data.editorWidth = editorWidth
                data.editorHeight = editorHeight

                createLabelingModal(editor, command, data);
            }
        },{
            name: 'shrink',
            icon: 'action-next',
            text: 'Schrumpfen',
            action: (editor:Editor, command:string) => {
                const node = setWindowNode(editor);
                changeNodeSize(editor, node, -0.1);
                
            }
        },{
            name: 'expande',
            icon: 'action-prev',
            text: 'Vergrößern',
            action: (editor:Editor, command:string) => {
                const node = setWindowNode(editor);
                changeNodeSize(editor, node, 0.1);
                
            }
        }],
        buttonAction: (command:string) => {
            const empty = {
                type: "la",
                points: '',
                solutions: {},
                url: '',
            }
            createLabelingModal(editor, command, empty);
        },
        commandAction: (data:LabelingData) => {
            insertLabeling(data, editor);
        }    
    }
    const feature = new FeatureClass(config);
    feature.addToEditor(editor);
}


// For Resizing -> super UGL!!!
function changeNodeSize(editor:Editor, node:HTMLElement, percentageAdd:number){

    const data = getData(node);


    const f = node.querySelector(".img-holder");
    const width = transformLength(f.style.width);
    const height = transformLength(f.style.height);

    const newWidth = width * (1+percentageAdd);
    const newHeight = height * (1+percentageAdd);

    f.style.width = newWidth + "px"
    f.style.height = newHeight + "px"

    f.style.backgroundSize = newWidth + "px " + newHeight + "px";

    $(f).removeAttr('width');
    $(f).removeAttr('height');
    $(f).removeAttr('data-mce-style')
    $(node).removeAttr('data-mce-style')

    // reset top level data
    data.height = newHeight
    data.width = newWidth;

    const json = toJsonHtml(data);

    $(node).attr('data-json', json);
    const newElement = $(node).html(f);
    const test = newElement.prop('outerHTML')

    insertToEditor(test, editor)


    // ACHTUNG!!!! HIER KANN MAN IWIE NICHT VERKLEINERN; SODASS ES RICHTIG GESPEICHERT WIRD; STATT NUR IN data-mce-style...

}

// To give all picture the ability to easily become a labeling task, like graphics for example
export function turnPictureToLabelingTask(){

    return {
        name: 'add-img-to-label-task',
        icon: 'plus',
        text: 'Beschriftungsaufgabe',
        action: (editor:Editor) => {
            const node = setWindowNode(editor)
            const url = $(node).attr('src');
            
            const data = {
                type: "la",
                solutions: {},
                points: '',
                url: url, 
            }
            const command = 'insertlabeling'
            createLabelingModal(editor, command, data);
        }
    }
}

/**
 * Modal to Edit
 * @param editor 
 * @param command 
 * @param data 
 */

function createLabelingModal(editor:Editor, command:string, data:LabelingData){
    
    const content = '<div class="label-modal">' + 
        '<div class="row mb-2">' + 
            '<div class="col-6"><p class="labeling-info">' + renderInfo(data.type) + '</p></div>' + 
            '<div class="col-6 text-end">' + 
               '<button class="btn btn-light-success text-success add-label me-2">' +
                    '<i class="mdi mdi-plus-circle-outline"></i> Feld ' + 
                '</button>' + 
                renderSelect(data.type) + 
            '</div>' + 
        '</div>' + 
        '<div class="row" style="min-height: 200px;">' + 
            '<div class="col-md-12 col-sm-12 text-center">' + 
                renderPicture(data) +
            '</div>' +
        '</div>' + 
    '</div>'; 

    const settings = {
        submitBtn: {
            text: "Einfügen",
            class: "add-label-input",
        },
        leftInput: {
            placeholder: "",
            text: "Punkte",
            type: "text",
            value: data.points,
        },
        id: data.id,
        size: "xl",
    }

    const modalId = "create-label-task";
    const onclick = function(modal:JQuery){
        const data = getDataFromModal(modal);
        if (data){
            return insertData(data, editor, command, modalId);
        }
    }

    const modal = makeEditorModal(modalId, "Beschriftungs-/Zuordnungsaufgabe erstellen", content, settings, onclick, addListeners)

    // Hier so laden, dass man das Bild noch hochladen kann, muss leider später gemacht werden...
    if (data.url == ''){
        $("#label-picture-wrapper").html('<div id="label-uploader" class="p-1" style="max-width: 300px; margin:auto;"></div>')

        const insert = function(url:string){
            
            const html = renderPictureWithUrl(url);
            const wrapper = $("#label-picture-wrapper") 
            wrapper.html(html)
        }
        showInsertImage(insert, "#label-uploader");
    }

    makeItemsDraggable();
}

/* Listeners */
function addListeners(modal){
    modal.on("click", ".add-label", function(){
        addLabel();
    })
    modal.on("click", ".remove-label", function(){
        removeLabel(this);
    })
    modal.on("change", "#label-type", function(){
        const type = $(this).val().toString();
        toggleLabelType(type);
    });
    modal.on("blur change input", ".label-item input", function(){
        const inside = $(this).val().toString();
        if (inside.length > 5){
            const width = getInputFieldWidth(inside);
            $(this).parents(".label-item").css("width", width + "px");
        }
    })
}

function removeLabel(btn:HTMLElement){
    const confirmed = confirm("Sicher, dass du dieses Feld löschen möchtest?");
    if (confirmed){
        $(btn).parents(".label-item").remove();
    }
}

function addLabel(){

    if (document.getElementById("img-holder") !== null){
        const html = renderNewLabel();
        $("#img-holder").append(html);
        makeItemsDraggable();
    } else {
        errorToast("Du musst erst ein Bild hochladen/auswählen", "Achtung", 3250, true)
    }
}

function makeItemsDraggable(){
    $(".label-item").draggable({
        handle: ".handle-label"
    });
}

function renderNewLabel(){

    const [width, height] = getSizes();

    let left = 70;
    let top = 40;

    // 

    let c = 1;
    while (checkIfPositionIsFull(top, left)){
        c += 1;
        top = 40 * c;
        // 
    }

    top = top / height * 100;
    left = left /  width * 100;

    return renderLabel('', top, left);
}

function checkIfPositionIsFull(itemTop:number, itemLeft:number){
    const existingItems = $(".label-item");
    let exists = false;

    // const [width, height] = getSizes();

    existingItems.each((ind, obj) => {

        const pos = getItemPosition(obj);

        // 
        // 
        // 

        if (pos.top <= itemTop && pos.top >= itemTop - 30  && pos.left >= itemLeft - 5 && pos.left <= itemLeft + pos.width + 5){
            // There is already an item in the area
            // 
            // 

            exists = true;
        }
    })
    return exists;
}


function renderLabel(value = '', top:number, left:number){
    let s = '';
    const width = getInputFieldWidth(value)
    s += '<div class="label-item position-absolute" style="left: ' + left + '%; top: ' + top + '%; width:' + width + 'px;">' + 
        '<div class="position-relative">' + 
            '<input type="text" class="form-control check-field" value="' + value + '">' +
            '<span class="remove-label position-absolute text-danger" style="right: -8px; top: -8px; cursor: pointer; z-index: 999; font-size: 14px;"><i class="fa fa-times-circle"></i></span>' +
            '<span class="handle-label position-absolute text-info" style="left: -16px; top: 22%; cursor: pointer; z-index: 999; font-size: 14px;"><i class="fa fa-arrows-alt"></i></span>' +
            '</div>' + 
    '</div>'
    return s;
}

function getInputFieldWidth(value:string){
    let length = 70;
    if (value.length > 5){
        length += (value.length - 5) * 7;
    }
    return length;
}

function getSizes(){
    const h = $("#img-holder").find("img");
    return [h.width(), h.height()];
}


function toggleLabelType(type:string){
    // la or dr
    
    const html = renderInfo(type);
    $(".labeling-info").html(html);
}

function getDataFromModal(modal:JQuery):LabelingData{
    const errors = [];

    const points = getPoints(modal);
    const type = modal.find("#label-type").val().toString();

    const img = modal.find("#img-holder img")
    if (img == undefined){
        errors.push("Bitte lade erst ein Bild hoch");
    }

    const url = img.attr('src')
    const [width, height] = getSizes()

    const solutions = [];
    const items = modal.find(".label-item");

    let missingEntries = 0;
    items.each((ind, obj) => {
        const data = getLabelItemData(ind, obj, width, height);
        solutions.push(data);

        if (data.correct == ''){ // no input given
            $(obj).find("input").addClass("is-invalid");
            missingEntries += 1;
        }
    })

    if (!pointsValid(points)){
        errors.push("Die Eingabe braucht eine gültige Punktzahl")
    }

    if (missingEntries > 0){
        errors.push("Bei " + missingEntries + " Feldern fehlt noch eine Antwort");
    }

    if (solutions.length == 0){
        errors.push('Es muss mindestens ein Feld erstellt werden');
    }

    const id = getModalInputId(modal);

    if (errors.length == 0){
        return {
            id: id,
            type: type,
            points: points,
            solutions: solutions,
            url: url,
            width: width,
            height: height,
        }
    } else {
        displayErrors(errors);
        return false;
    }
}

// maybe do sth with index
function getLabelItemData(index:number, obj:HTMLElement, imageWidth:number, imageHeight:number):SingleLabel {
    const data = getItemPosition(obj, {width: imageWidth,height: imageHeight});
    const value = $(obj).find("input").val().toString().replace(",", ".");
    data.correct = value; // do not switch depending on type here! -> but do it later and switch for uniqueid
    return data;
}

/**
 * 
 * @param obj 
 * @param imageWidth
 * @returns -> if imageWidth false: return in px, otherwise in percent of imageWidth
 */
function getItemPosition(obj:HTMLElement, image:{width:number, height:number}|boolean = false):any{
    
    let top = Number($(obj).css('top').replace('px', ''));
    let left = Number($(obj).css('left').replace('px', ''));
    const width = Number($(obj).css('width').replace('px', ''));

    if (image){
        top = top / image.height * 100;
        left = left / image.width * 100;
    }

    return {
        top: top,
        left: left,
        width: width,
    }
}

function insertLabelingField(data:LabelingData, editor:Editor){

}


function renderPicture(data:LabelingData){
    let s = '<div id="label-picture-wrapper" class="py-4">';
    if (data.width !== undefined){
        s += '<input type="hidden" id="editor-width" value="' + data.width + '"><input type="hidden" id="editor-height" value="' + data.height + '">';
    }
    if (data.url != ''){ // Is there a picture
        s += renderPictureWithUrl(data.url);
   //     s += '<div id="label-picture" data-url="' + data.url + '" '

        if (data.solutions.length > 0){
            s += renderLabels(data.solutions); // Here Change for Drag'n'Drop
        }

        s += '</div>'
    }
    s += '</div>' 
    return s;
}

function renderPictureWithUrl(url:string){
    let s = '';
    s += '<div id="img-holder" class="position-relative d-inline-block" style="max-width: 750px; max-height: 800px; margin:auto;"><img src="' + url + '" style="object-fit: cover; max-width: 100%; max-height: 800px;">'
    return s;
}

function renderLabels(solutions:any){
    let s = '';
    solutions.forEach((item:SingleLabel) => {
        s += renderLabel(item.correct.toString(), item.top, item.left);
    })
    return s;
}

function renderInfo(type:string){
    if (type == "la"){
        return 'Du kannst hier mehrere Eingabefelder auf einem Bild darstellen';
    } else if (type == "dr"){
        return 'Du kannst Drag and Drop - Aufgaben erstellen';
    }
}

function renderSelect(type:string){
    let s = '<select id="label-type" class="form-control form-select">'
    const types = [["la", "Beschriftung"], ["dr", "Drag and Drop"]]

    types.forEach((info) => {
        s += '<option value="' + info[0] + '"'
        if (info[0] == type){
            s += ' selected'
        }
        s += '>' + info[1] + '</option>'
    })

    s += '</select>'
    return s;
}

/**
 * Inserts
 */

function insertLabeling(data:LabelingData, editor:Editor){
    const html = renderDataForEditor(data);
    insertToEditor(html, editor);
}

// Render Data for Editor

function renderDataForEditor(data:LabelingData):string{
    let s = '';

    let [width, height] = getCurrentSizesInEditor();
    if (width !== undefined){
        data.width = width;
        data.height = height;
    } else {
        width = data.width;
        height = data.height;
    }



    const json = toJsonHtml(data);
 
    // let width = (data.editorWidth !== undefined) ? data.editorWidth : data.width;
    // let height = (data.editorHeight !== undefined) ? data.editorHeight : data.height;
 
    

    

    s += '<div id="labeling" ' +
    ' class="mceNonEditable d-inline-block input-item position-relative" data-id="' + data.id + '" data-json="' + json + '">';
    s += '<div class="img-holder d-inline-block position-relative" ' +
    ' style="background-image: url(\'' + data.url + '\'); background-size: ' + width + 'px ' + height + 'px; width: ' + width + 'px; height: ' + height + 'px;"' +
    '>';

    s += renderLabelsForEditor(data.type, data.solutions);

    if (data.type == "la"){

    } else if (data.type == "dr"){
        s += renderLabelsDragDrop(data.solutions);
    }

    s += '</div>'

    s += '</div>';
    return s;
}

function getCurrentSizesInEditor(){
    const modal = $(".label-modal");
    const width = modal.find("#editor-width").val();
    const height = modal.find("#editor-height").val();

    return [width, height];
}


// Labeling

    // Render Drag'n'Drop Labels for Editor
    function renderLabelsDragDrop(solutions:Array<SingleLabel>):string {
        let s = '<div class="p-2 d-inline-block position-absolute" style="right: 0;">';
        solutions.forEach((item) => {
            s += renderDragDropLabel(item);
        })
        s += '</div>' 
        return s;
    }

    function renderDragDropLabel(item:SingleLabel):string {
        let s ='';
        const w = getInputFieldWidth(item.correct.toString());
        s += '<div>' + 
            '<input type="text" disabled value="' + item.correct + '" class="form-control" style="width: ' + w + 'px">' + 
            '</div>'
        return s;
    }


    // Render Labels for Editor
    function renderLabelsForEditor(type:string, solutions:Array<SingleLabel>):string {
        let s = '';
        solutions.forEach((item) => {
            s += renderLabelForEditor(item, type);
        })
        return s;
    }

    // Render Label for Editor
    function renderLabelForEditor(item:SingleLabel, type:string):string{
        let s = '';
        s += '<div class="label-item position-absolute" style="left: ' + item.left + '%; top: ' + item.top + '%; width:' + item.width + 'px;">' +
        '<div class="position-relative">'
        if (type == "la"){
            s += '<input type="text" disabled class="form-control" value="' + item.correct + '">'
        } else if (type == "dr"){
            s += '<div style="opacity: 0.7 !important;" class="w-100 form-control"></div>'
        }

        s += '</div></div>'

        return s;
    }

    // Render Label for Editor DragDrop

// Render Data for Display

export function transformLabeling(data:LabelingData, ind:number){
    
    const [html, solutions] = displayCodeLabeling(data, ind);
    const exportSolutions = minifySolutions(solutions);

    return {
        solution: {
            type: data.type,
            id: data.id,
            points: data.points,
            correct: exportSolutions,
        },
        html: html,
    }
}

function minifySolutions(solutions:Array<SingleLabel>):Array<SingleLabelSolution> {
    const minSolutions = [];
    let minSolution:any;
    solutions.forEach((item) => {
        
        if (item.value !== undefined){
            minSolution = {
                correct: item.correct,
                value: item.value
            };
        } else {
            minSolution = item.correct;
        }
        minSolutions.push(minSolution);
    })
    return minSolutions;
}



// Display Code
function displayCodeLabeling(data:LabelingData, index:number):[string, Array<SingleLabel>] {
    let s = '';
 
    const width = (data.editorWidth !== undefined) ? data.editorWidth : data.width;
    const height = (data.editorHeight !== undefined) ? data.editorHeight : data.height;
 
    s += '<div ' +
    ' class="d-inline-block input" data-type="' + data.type + '" data-id="' + data.id + '" data-name="' + data.id + '_' + index + '">';
    s += '<div class="img-holder d-inline-block position-relative" width="' + width + 'px" height="' + height + 'px" ' +
    ' style="background-image: url(\'' + data.url + '\'); background-size: ' + width + 'px ' + height + 'px; width: ' + width + 'px; height: ' + height + 'px;"' +
    '>';

    s += renderLabelsForDisplay(data.type, data.solutions);
    if (data.type == "la"){

    } else if (data.type == "dr"){
        const [add, solutions] = renderLabelsDragDropForDisplay(data.solutions);
        s += add;
        data.solutions = solutions;
    }
    s += '</div>'





    s += '</div>';
    return [s, data.solutions];
}

    // Render Labels for Display
    function renderLabelsForDisplay(type:string, solutions:Array<SingleLabel>):string {
        let s = '';
        solutions.forEach((item, index) => {
            s += renderLabelForDisplay(item, type, index);
        })
        return s;
    }


    // Render Label for Display
    function renderLabelForDisplay(item:SingleLabel, type:string, index:number):string{
        let s = '';
        const width = (type == "la") ? item.width : 80;
        s += '<div class="label-item position-absolute" style="left: ' + item.left + '%; top: ' + item.top + '%; width:' + width + 'px;">' +
        '<div class="position-relative">'
        if (type == "la"){
            s += '<input type="text" class="form-control" data-index="' + index + '">'
        } else if (type == "dr"){
            s += '<div style="opacity: 0.7 !important; height: 34px !important;" data-index="' + index + '" class="w-100 form-control btn-light-success drag-target"></div>'
        }
        s += '</div></div>'
        return s;
    }

    function renderLabelsDragDropForDisplay(solutions:Array<SingleLabel>):[string, Array<SingleLabel>] {
        let s= '';
        const ids = [];
        solutions.forEach((item, index) => {

            let checkValue = getRandomInt(1, 99);
            while (ids.includes(checkValue)){ // checks if has been used
                checkValue = getRandomInt(1,99);
            }
            ids.push(checkValue);

            const value = item.correct;

            solutions[index].value = item.correct;
            solutions[index].correct = checkValue;

            s += renderDragDropLabelForDisplay(item, index, value);
        })
        return [s, solutions];
    }

    // item.correct is already the id and value is the term inside
    function renderDragDropLabelForDisplay(item:SingleLabel, index:number, value:string|number):string {

        const top = index * 40;

        const w = getInputFieldWidth(value.toString());

        let s ='';
        s += '<span class="form-control drag-drop position-absolute" data-target="-1" style="width: ' + w + 'px; right:0px; top:'+top +'px;" data-id="' + item.correct + '" data-target="-1">' + value + '</span>'
        return s;
    }

    // Rerender
    function rerenderDragDropLabelsDisplay(taskId:number, holder = '.label-holder'){
        const html = '';
        const top = 40;
        $(".input[data-id='" + taskId + "']").find(".drag-drop[data-target=-1]").each((ind, obj) => {
            $(obj).css("left", "auto");
            $(obj).css("top", ind * top);  
            $(obj).css("visibility", "visible");
        })
    }


    // Add Functionality to all Drag'n'Drops
    export function addDraggingToDragDrops(){
        const inputs = $(".input[data-type='dr']");
        if (inputs.length > 0){
            inputs.each((ind, obj) => {
                const id = Number($(obj).attr('data-id'));
                addDraggableFunctionDragDropInput(id);
            })
        }
    }


    // Draggable Function
    function addDraggableFunctionDragDropInput(id:number){
        const wrapperElement = ".input[data-id='" + id + "']"
        const element = $(wrapperElement);

        const elements = element.find(".drag-drop")
        if (elements.length > 0){
            elements.draggable({
                snap: wrapperElement + " .drag-target",
                snapMode: "inner",
                containment: wrapperElement,
            })
        }

        const targets = $(wrapperElement).find(".drag-target")
        targets.each((ind, obj) => {

            $(obj).droppable({
                hoverClass: "drag-drop-hover",
                tolerance: "touch",
                over: (event, ui) => {
                   // 
                },
                drop: function(event, ui){
               
                    const currentTarget = event.target.getAttribute('data-index');
                    const [used, by] = isTargetUsed(wrapperElement, currentTarget, ui.draggable);

                    const val = $(ui.draggable).html();

                    $(ui.draggable).attr('data-target', currentTarget);
                    $(ui.draggable).css('top', $(event.target).parents(".label-item").css("top"))
                    $(ui.draggable).css('left', $(event.target).parents(".label-item").css("left"))

                    const targetWidth = Number($(event.target).parents(".label-item").css("width").replace("px", ""))
                    const currentWidth = $(ui.draggable).width();

                    
                    

                    if (currentWidth < targetWidth){

                        $(ui.draggable).css('width', targetWidth)
                    }

                    if (used){
                        
                        $(by).attr('data-target', -1);
                        rerenderDragDropLabelsDisplay(id);
                    }

                    
                }
            })
        })
    }

    function isTargetUsed(wrapperElement:string, targetId:number, currentElement:HTMLElement){
        let used = false;
        let el = false;
        if (Number($(currentElement).attr('data-target')) != targetId){
            $(wrapperElement).find(".drag-drop").each((ind, obj) => {
            //    
                if (Number(obj.getAttribute('data-target')) == targetId){
                    used = true;
                    el = obj;
                }
            })
        }
        return [used, el];
    }